
<oe-flat-widget [title]="imageTitle1" [icon]="{name: 'oe-sp', color:'environmental'}">
  <img [src]="imageData1" alt="Logo" class="image-container">
</oe-flat-widget>





